<template>
	<div id="record">
		<div class="content-table">
			<el-table :data="tableData.list" border style="width: 100%">
				<el-table-column align="center" prop="cropNo" label="床号(刀号)"></el-table-column>
				<el-table-column align="center" prop="goodsName" label="商品">
				</el-table-column>
				<el-table-column align="center" prop="goodsNo" label="货号">
				</el-table-column>
				<el-table-column align="center" label="商品图">
					<template slot-scope="scope">
						<img :src="scope.row.goodsUrls" width="100" height="100" />
					</template>
				</el-table-column>
				<el-table-column align="center" label="已领取">
					<template slot-scope="scope">
						<span>{{scope.row.receiveCount}}包</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="createTime" label="最近一次领货"></el-table-column>
				<el-table-column align="center" fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="primary" round size="small" @click="userEdit(scope)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="params.page"
			:page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next"
			:total="tableData.totalCount" class="pagination"></el-pagination>
	</div>
</template>

<script>
	import {
		loadCompanyRecordOperateList
	} from '@/api/index'
	import {
		prefixAssetImage,
		isEmpty
	} from '@/utils/util';

	export default {
		name: "record",
		data() {
			return {
				params: {
					page: 1,
					size: 10,
					searchKey: ''
				},
				tableData: {
					list: []
				}
			}
		},
		created() {
			this.loadCompanyRecordOperateList();
		},
		methods: {
			sizeChange(val) {
				this.params.size = val;
				this.params.page = 1;
				this.loadCompanyRecordOperateList();
			},
			pageChange(val) {
				this.params.page = val;
				this.loadCompanyRecordOperateList();
			},
			loadCompanyRecordOperateList: async function() {
				let params = this.params;
				let result = await loadCompanyRecordOperateList(params);
				if (result.status == 1) {
					for (let item of result.data.list) {
						if (!isEmpty(item.goodsUrls))
							item.goodsUrls = prefixAssetImage(item.goodsUrls)
					}
					this.tableData = result.data;
				}
			}
		}
	};
</script>

<style lang="scss">
	#record {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.content-table {
			width: 96%;
			margin-top: 2%;
		}

		.pagination {
			width: 96%;
			margin: 2% 0;
		}
	}
</style>